module.exports = __webpack_public_path__ + "media/images/topbild-1300-ae0fe65ec4efd6d593ce6ddee467bd82.jpg";